import React from 'react';
import MetadataFull from './MetadataFull';
import { DOI } from '../utils/api';

export default function DetailsSection({ metadata }: { metadata: DOI }) {
    return <MetadataFull metadata={metadata} />
};
